import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import valuesImage from '../../../assets/images/home/values.png';
import solidarityImage from '../../../assets/images/home/solidarity.jpg';
import phoneIcon from '../../../assets/images/home/phone.svg';
import { ROUTE_LOGIN } from '../../../routes';
import { get } from '../../../container';

export default class Home extends Component {
  render() {
    return (
      <div className="homepage">
        <div className="banner">
            <a href="tel:0426244722" className="banner__content">
                <img src={phoneIcon} alt="" />
                04 26 24 47 22
            </a>
        </div>
        <div className="container">
            <header className="header">
                <h1>
                    Un temps
                    <span>pour un autre</span>
                </h1>
                <p className="subtitle">
                    Une heure de service rendu est égale à une
                    <span>heure de service reçu !</span>
                </p>
                <div className="header__buttons">
                    <Link to={ROUTE_LOGIN} className="button">Se connecter</Link>
                    <a href="#nous-rejoindre" className="link">Comment nous rejoindre ?</a>
                </div>
            </header>
            <section>
                <img src={valuesImage} alt="" />
                <div className="text-block">
                    <h2>Des échanges de services gratuits entre particuliers</h2>
                    <p>Charlotte a joliment restauré le coffret en bois de Raymonde et en échange, Romain a nourri les animaux de Charlotte pendant l‘été.</p>
                    <p>Laure donne des cours de soutien scolaire à Aïcha, 8 ans et en échange sa maman fait des travaux de couture à Sébastien.</p>
                    <p>Annie aide Julien, 20 ans, pour une remise à niveau en maths et chimie et en échange Roger taille les haies du jardin d’Annie.</p>
                    <p>Juliette tient compagnie à la maman d’Élisabeth qui en échange donne des cours de peinture sur porcelaine.</p>
                    <p>Marie donne des cours de conversation française à Harry, un anglais de 40 ans et en échange, Dominique a fait quelques petits travaux de bricolage dans la maison de Marie.</p>
                </div>
            </section>
            <section>
                <div className="text-block">
                    <h2>Fonctionnement des échanges</h2>
                    <p>L’échange repose sur le temps et non l’argent. Une heure de service rendu est égale à une heure de service reçu.</p>
                    <p>Chaque membre met ses compétences au service des autres sous forme d’<span className="highlight">offres de services</span> : bricolage, jardinage, garde d’enfants, soutien scolaire, covoiturage, ménage, repassage, couture, aide aux démarches administratives, informatique, musique, langues...</p>
                    <p>Chaque échange est comptabilisé dans une banque de temps où sont inscrites les heures données et les heures reçues. La comptabilité se fait à partir des « chèques temps ». <span className="highlight">À l’inscription, chaque membre dispose de 10 heures</span> pour lui permettre d’échanger des services immédiatement.</p>
                    <p>L’adhésion à l’association est de <span className="highlight">10€</span> par an et implique que chaque membre participe aux échanges par des offres et des demandes afin d’assurer la survie du système.</p>
                    <p>L’association propose aussi des ateliers tout au long de l’année :</p>
                    <ul>
                        <li>Conversation anglaise</li>
                        <li>Atelier couture : une fois par mois</li>
                        <li>Atelier chocolat : au moment des fêtes</li>
                        <li>Atelier décoration de Noël</li>
                        <li>Atelier informatique</li>
                        <li>Repair Café 2ème samedi du mois 9h30 - 12h</li>
                    </ul>
                    <p>Ces ateliers permettent de belles rencontres tout en partageant des savoirs et en s’entraidant.</p>
                </div>
                <img src={solidarityImage} alt="" />
            </section>
        </div>
        <footer className="footer">
            <div className="container">
                <h3 id="nous-rejoindre">Comment nous rejoindre</h3>
                <p>Venez partager autour d’un café vos compétences et vos demandes. Nous vous expliquerons comment faire votre adhésion pour accéder au logiciel et recevoir votre chéquier d’échange.</p>
                <div className="footer__info">
                    <div className="hours">
                        <div className="permanences">
                            <strong>Permanences</strong>
                            <span>mardi de 10h00 à 11h00</span>
                            <span>jeudi de 17h30 à 18h30</span>
                        </div>
                    </div>
                    <div className="contact-details">
                        <div className="address">
                            <strong>Association "Un Temps Pour Un Autre"</strong>
                            <i>
                                <strong>50 place centrale</strong> (derrière la pharmacie Leduc)
                            </i>
                            <strong>42153 Riorges</strong>
                        </div>
                        <div className="phone-number">
                            <img src={phoneIcon} alt="" />
                            <div>
                                <strong>04 26 24 47 22</strong>
                                <i>(uniquement aux horaires de permanence)</i>
                            </div>
                        </div>
                        <div className="buttons">
                            <a  href="https://www.facebook.com/untempspourunautre/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button button--full button--medium button--icon">
                                <svg version="1.1" x="0" y="0" viewBox="0 0 1298 2500" width="15">
                                    <path fill="#ffffff" d="M842.5,2499.7V1359.6h382.7l57.3-444.3h-440V631.6c0-128.6,35.7-216.3,220.2-216.3l235.3-0.1V17.8
                                    c-40.7-5.4-180.4-17.5-342.8-17.5c-339.2,0-571.5,207.1-571.5,587.3v327.7H0v444.3h383.7v1140.1L842.5,2499.7L842.5,2499.7z"/>
                                </svg>
                            </a>
                            <a href={`mailto:${get('utpa_email')}`} className="button button--full button--medium">Nous écrire</a>
                            <a
                                href="https://www.google.fr/maps/place/50+Place+Centrale,+42153+Riorges/@46.0430897,4.0315443,17z/data=!3m1!4b1!4m5!3m4!1s0x47f405c75c477c43:0xc4561caab47ac58!8m2!3d46.043086!4d4.033733"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button button--full button--medium"
                            >
                                Itinéraire
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer__legal">© 2018 Un Temps Pour Un Autre</div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/home/components/Home.js